<template>
  <aside class="main-sidebar">

    <!-- sidebar: style can be found in sidebar.less -->
    <section class="sidebar">

      <!-- search form (Optional) -->
      <div class="sidebar-form" v-show="isShowSearch">
        <div class="input-group">
          <input type="text"
                 name="search"
                 id="search"
                 class="search form-control"
                 placeholder="Search..."
          v-model="searchKey">
          <span class="input-group-btn">
            <button name="search" @click="toDoSearch" id="search-btn" class="btn btn-flat">
              <i class="fa fa-search"></i>
            </button>
          </span>
        </div>
      </div>
      <!-- /.search form -->

      <!-- Sidebar Menu -->
      <sidebar-menu/>
      <!-- /.sidebar-menu -->

      <!--version-->
      <p class="version-data" v-show="isShowVersion">{{buildVersion + '&nbsp;(' + buildSHA + ')'}}</p>
      <!--version-->

    </section>
    <!-- /.sidebar -->
  </aside>

</template>
<script>
  import SidebarMenu from './SidebarMenu'
  import config from '../config'

  export default {
    name: 'Sidebar',
    props: ['displayName', 'pictureUrl'],
    components: {SidebarMenu},
    computed: {
      isShowSearch: function () {
        if (this.$route.path === '/' || this.$route.path === '/agent' ||
          this.$route.path === '/device' || this.$route.path === '/deviceuser') {
          return true
        } else {
          return false
        }
      }
    },
    data () {
      return {
        searchKey: '',
        buildVersion: '1.0.0',
        buildSHA: '9999999',
        isShowVersion: true
      }
    },
    mounted: function () {
      this.buildVersion = config.buildVersion
      this.buildSHA = config.buildSHA
//      window.jQuery('[data-toggle="hideseek"]').off().hideseek()
      var that = this
      window.jQuery('#search').keydown(function (event) {
        if (event.which === 13) {
          that.toDoSearch()
        }
      })
    },
    created () {
      this.$bus.on('showsearchuserkey', this.setSearchKey)
      this.$bus.on('ShowBuildVersion', this.setBuildVersion)
    },
    beforeDestroy () {
      this.$bus.off('showsearchuserkey', this.setSearchKey)
      this.$bus.off('ShowBuildVersion', this.setBuildVersion)
    },
    methods: {
      setBuildVersion (datas) {
        this.isShowVersion = datas.isShow
      },
      setSearchKey (datas) {
        this.searchKey = datas.key
      },
      toDoSearch () {
//        if (utils.isEmpty(window.jQuery('#search').val().trim())) {
//          return
//        }
        if (this.$route.path === '/') {
          this.toDoSearchApp()
          return
        }

        if (this.$route.path === '/agent') {
          this.toDoSearchAgent()
          return
        }

        if (this.$route.path === '/device') {
          this.toDoSearchDevice()
          return
        }
        if (this.$route.path === '/deviceuser') {
          this.toDoSearchDeviceUser()
          return
        }
      },
      toDoSearchApp () {
        this.$bus.emit('searchapp', { key: this.searchKey.trim() })
      },
      toDoSearchAgent () {
        this.$bus.emit('searchagent', { key: this.searchKey.trim() })
      },
      toDoSearchDevice () {
        this.$bus.emit('searchdevice', { key: this.searchKey.trim() })
      },
      toDoSearchDeviceUser () {
        this.$bus.emit('searchdeviceuser', { key: this.searchKey.trim() })
      }
    }
  }
</script>
<style>
  .user-panel .image img {
    border-radius: 50%;
  }
</style>



// WEBPACK FOOTER //
// Sidebar.vue?c769fe9c